import { render, staticRenderFns } from "./productsliderdetails.vue?vue&type=template&id=917b1142&scoped=true&"
import script from "./productsliderdetails.vue?vue&type=script&lang=js&"
export * from "./productsliderdetails.vue?vue&type=script&lang=js&"
import style0 from "./productsliderdetails.vue?vue&type=style&index=0&id=917b1142&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "917b1142",
  null
  
)

export default component.exports